/* eslint-disable import/no-anonymous-default-export */
// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:11-10-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION
import GroupReportTypes from './group.report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	fetchAllGroupReportResp: null,
	fetchAllGroupReportArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** Fetch Group Details Start ******************/
		case GroupReportTypes.GET_GROUP_REPORT_SUCCESS:
			return {
				...state,
				fetchAllGroupReportResp: action.payload,
				fetchAllGroupReportArr: docodeHexResponse(action.payload, 'GetAllGroupReportKey'),
			};

		case GroupReportTypes.GET_GROUP_REPORT_FAILURE:
			return { ...state, fetchAllGroupReportResp: action.payload };

		case GroupReportTypes.GET_GROUP_REPORT_RESPONSE_RESET_CHANGED:
			return { ...state, fetchAllGroupReportResp: null };

		/*************** Fetch Group Details Start ******************/

		default:
			return state;
	}
};
